import { render } from "./Index.vue?vue&type=template&id=5888ac20"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5888ac20&lang=less"

import exportComponent from "/root/workspace/want-ceo-backstage-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__